/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:SOCIAL
 */


(function (M, _, $, Backbone) {
  'use strict';

  M.View = M.View || {};

  /**
    * @class FavoriteAndShareLinks
    *
    * Renders a widget containing adding like and social sharing links.
    * (e.g. facebook, pinterest, G+, twitter).
    * 
    * Arguments:
    * - likeLinkOptions: dictionary (optional) - see like_link.js
    * - shareLinksOptions: dictionary (optional) - see share_links.js
    *
    * if you do not pass the option of one type, that type of share link will not
    * be created.
    *
    * required: css_include("/static/compiled/css/v2/themes/community/site.css")
    */
  M.View.FavoriteAndShareLinks = Backbone.View.extend({
    tagName: 'div', 
    className: 'favoriteAndShareLinks',

    options: {
      likeLinkOptions: null,
      shareLinksOptions: null
    },

    initialize: function() {
      this.$el = $(this.el);
      this.likeLink = null;
      this.shareLinks = null;

      if (this.options.likeLinkOptions) {
        var likeModel;
        if (typeof this.options.sku !== 'undefined') {
          likeModel = new M.Model.ProductFavorite({
            // the url to post is still hard coded
            sku: this.options.get('sku'),
            isliked: this.options.isLiked
          });
        }
        else {
          likeModel = new M.Model.DesignLike({
            isliked: this.options.isLiked,
            urlPaths: this.options.urlPaths
          });
        }
        this.options.likeLinkOptions['model'] = likeModel;
        this.likeLink = new M.View.LikeLink(this.options.likeLinkOptions);
      }
    },

    render: function() {
      if (this.likeLink) {
        this.$el.append(this.likeLink.render().el);
      }

      if (this.options.shareLinksOptions) {
        // Create a new container for the share links widget
        var $newElement = $('<div></div>');
        var newOptions = { el: $newElement };
        var shareOptions = _.extend(this.options.shareLinksOptions, newOptions);

        this.shareLinks = new M.View.ShareLinks(shareOptions);
        this.$el.append($newElement);
      }

      return this;
    }
  });

})(M, _, $, Backbone);

